// Norne
import centerId_0000 from "./svg/norne/norne-logo-light.svg";
import norneBlueLogo from "./svg/norne/norne-logo-blue.svg";
// Sparebanken Vest
import centerId_3305 from "./svg/sparebankenVest/logo.svg";
import centerId_3601 from "./svg/sparebankenVest/logo.svg";
// Fana Sparebank
import centerId_3411 from "./svg/fanaSparebank/logo.svg";
// Voss Sparebank
import centerId_3480 from "./svg/vossSparebank/logo.svg";
// Sparebanken Møre
import centerId_3910 from "./svg/sparebankenMore/logo.svg";
// Sparebanken Øst
import centerId_2220 from "./svg/sparebankenOst/logo.svg";
// Flekkefjord Sparebank
import centerId_3030 from "./svg/flekkefjordSparebank/logo.svg";
// Haugesund Sparebank
import centerId_3240 from "./svg/haugesundSparebank/logo.svg";
// Helgeland Sparebank
import centerId_4530 from "./svg/norne/norne-logo-blue.svg"; //byttet til Norne logo
// Lillesand Sparebank
import centerId_2850 from "./svg/lillesandSparebank/logo.svg";
// Luster Sparebank
import centerId_3785 from "./svg/lusterSparebank/logo.svg";
// OBOS
import centerId_9820 from "./svg/obos/logo.svg";
// Spareskillingsbanken
import centerId_3060 from "./svg/spareSkillingsBanken/logo.svg";
// Cultura
import centerId_1254 from "./svg/cultura/logo.svg";
// Skudenes & Aakra Sparebank
import centerId_3361 from "./svg/skudenesOgAakraSparebank/logo.svg";
// Søgne og Greipstad Sparebank
import centerId_3090 from "./svg/sogneOgGreipstadSparebank/logo.svg";
// Grue sparebank
import centerId_1830 from "./svg/grueSparebank/logo.svg";
// Sparebanken Sør
import centerId_2811 from "./svg/sparebankenSor/logo.svg";
// Etne Sparebank
import centerId_3543 from "./svg/etneSparebank/logo.svg";
// Sogn Sparebank
import centerId_3730 from "./svg/sognSparebank/logo.svg";
import centerId_3745 from "./svg/sognSparebank/logo.svg";
import centerId_3800 from "./svg/sognSparebank/logo.svg";
// Eika
import centerId_9090 from "./svg/eikaKapitalforvaltning/logo.svg";
// Sparebanken Sogn og Fjordane
import centerId_3890 from "./svg/sparebankenSognOgFjordane/logo.svg";
// Eidsberg Sparebank
import centerId_1020 from "./svg/eidsbergSparebank/logo.svg";
// Valdres Sparebank
import centerId_2146 from "./svg/valdresSparebank/logo.svg";
import centerId_2153 from "./svg/valdresSparebank/logo.svg";
// Tysnes Sparebank
import centerId_3525 from "./svg/tysnesSparebank/logo.svg";
// Strømmen Sparebank
import centerId_1310 from "./svg/strommenSparebank/logo.svg";
// Narvik Sparebank
import centerId_4520 from "./svg/sparebankenNarvik/logo.svg";
// Valle Sparebank
import centerId_2890 from "./svg/valleSparebank/logo.svg";
// Trøgstad Sparebank
import centerId_1140 from "./svg/trogstadSparebank/logo.svg";
// Totens Sparebank
import centerId_2050 from "./svg/totensSparebank/logo.svg";
// Sunndal Sparebank
import centerId_4035 from "./svg/sunndalSparebank/logo.svg";
// Stadsbygd Sparebank
import centerId_4336 from "./svg/stadsbygdSparebank/logo.svg";
// Skagerak Sparebank
import centerId_2655 from "./svg/skagerakSparebank/logo.svg";
import centerId_2601 from "./svg/skagerakSparebank/logo.svg";
import centerId_2510 from "./svg/skagerakSparebank/logo.svg";
// Bien Sparebank
import centerId_1720 from "./svg/bienSparebank/logo.svg";
// Skue Sparebank
import centerId_2351 from "./svg/skueSparebank/logo.svg";
import centerId_2333 from "./svg/skueSparebank/logo.svg";
import centerId_2230 from "./svg/skueSparebank/logo.svg";
import centerId_2699 from "./svg/skueSparebank/logo.svg";
// Soknedal Sparebank
import centerId_4333 from "./svg/soknedalSparebank/logo.svg";
// Trøndelag Sparebank
import centerId_4312 from "./svg/trondelagSparebank/logo.svg";
import centerId_4345 from "./svg/trondelagSparebank/logo.svg";
// Setskog Sparebank
import centerId_1280 from "./svg/setskogSparebank/logo.svg";
import centerId_1338 from "./svg/setskogSparebank/logo.svg";
// Selbu Sparebank
import centerId_4285 from "./svg/selbuSparebank/logo.svg";
// Oslofjord Sparebank
import centerId_1450 from "./svg/osloFjordSparebank/logo.svg";
// Rindal Sparebank
import centerId_4111 from "./svg/rindalSparebank/logo.svg";
// Romerike Sparebank
import centerId_1286 from "./svg/romerikeSparebank/logo.svg";
import centerId_1321 from "./svg/romerikeSparebank/logo.svg";
// Romsdalsbanken
import centerId_4075 from "./svg/romsdalsBanken/logo.svg";
import centerId_4106 from "./svg/romsdalsBanken/logo.svg";
// Odal Sparebank
import centerId_1870 from "./svg/odalSparebank/logo.svg";
// Oppdalsbanken
import centerId_4266 from "./svg/oppdalsBanken/logo.svg";
// Ørskog Sparebank
import centerId_4060 from "./svg/orskogSparebank/logo.svg";
// 68 grader nord
import centerId_4589 from "./svg/68GraderNord/logo.svg";
import centerId_4605 from "./svg/68GraderNord/logo.svg";
import centerId_4730 from "./svg/68GraderNord/logo.svg";
// Asen Sparebank
import centerId_4484 from "./svg/aasenSparebank/logo.svg";
// Andebu Sparebank
import centerId_2500 from "./svg/andebuSparebank/logo.svg";
// Askim og Spydeberg Sparebank
import centerId_1100 from "./svg/askimOgSpydebergSparebank/logo.svg";
import centerId_1135 from "./svg/askimOgSpydebergSparebank/logo.svg";
// Aurskog Sparebank
import centerId_1271 from "./svg/aurskogSparebank/logo.svg";
// Berg Sparebank
import centerId_1105 from "./svg/bergSparebank/logo.svg";
// Birkenes Sparebank
import centerId_2880 from "./svg/birkenesSparebank/logo.svg";
// Bjugn Sparebank
import centerId_4295 from "./svg/bjugnSparebank/logo.svg";
// Drangedal Sparebank
import centerId_2635 from "./svg/drangedalSparebank/logo.svg";
// Etnedal Sparebank
import centerId_2140 from "./svg/etnedalSparebank/logo.svg";
// Fjaler Sparebank
import centerId_3755 from "./svg/fjalerSparebank/logo.svg";
// Grong Sparebank
import centerId_4448 from "./svg/grongSparebank/logo.svg";
// Haltdalen Sparebank
import centerId_4355 from "./svg/haltdalenSparebank/logo.svg";
// Hegra Sparebank
import centerId_4465 from "./svg/hegraSparebank/logo.svg";
// Kvinesdal Sparebank
import centerId_3080 from "./svg/kvinesdalSparebank/logo.svg";
// Melhusbanken
import centerId_4230 from "./svg/melhusBanken/logo.svg";
// Hjelmeland Sparebank
import centerId_3353 from "./svg/hjelmelandSparebank/logo.svg";
// Marker Sparebank
import centerId_1050 from "./svg/markerSparebank/logo.svg";
// Nidaros Sparebank
import centerId_4358 from "./svg/nidarosSparebank/logo.svg";
// Ørland Sparebank
import centerId_4290 from "./svg/orlandSparebank/logo.svg";
// Jernbanepersonalets Bank
import centerId_1440 from "./svg/jernbanePersonaletsBank/logo.svg";
// Jæren sparebank
import centerId_3290 from "./svg/jaerenSparebank/logo.svg";
import centerId_3325 from "./svg/jaerenSparebank/logo.svg";
// Tinn Sparebank
import centerId_2620 from "./svg/tinnSparebank/logo.svg";
// Agder Sparebank
import centerId_2895 from "./svg/agderSparebank/logo.svg";
import centerId_2907 from "./svg/agderSparebank/logo.svg";
// Evje & Hornes Sparebank
import centerId_2901 from "./svg/evjeOgHornesSparebank/logo.svg";
// Norse Securities
import centerId_4001 from "./svg/norseSecurities/logo.svg";
// Orkla Sparebank
import centerId_4260 from "./svg/orklaSparebank/logo.svg";
import centerId_4270 from "./svg/orklaSparebank/logo.svg";
// Røros Sparebank
import centerId_4280 from "./svg/rorosBanken/logo.svg";
// Surnadal Sparebank
import centerId_4040 from "./svg/surnadalSparebank/logo.svg";
// Tolga-os Sparebank
import centerId_1885 from "./svg/tolgaOsSparebank/logo.svg";
// Vibrand
import centerId_1010 from "./svg/vibrand/logo.svg";
// Sparebanken DIN
import centerId_2630 from "./svg/sparebankenDin/logo.svg";
// Rogaland Sparebank
import centerId_3260 from "./svg/rogalandSparebank/logo.svg";

const Logos = {
  centerId_0000,
  norneBlueLogo,
  centerId_3305,
  centerId_3601,
  centerId_3910,
  centerId_3411,
  centerId_3480,
  centerId_2220,
  centerId_3030,
  centerId_3240,
  centerId_4530,
  centerId_2850,
  centerId_3785,
  centerId_9820,
  centerId_3060,
  centerId_1254,
  centerId_3361,
  centerId_3090,
  centerId_1830,
  centerId_2811,
  centerId_3543,
  centerId_3730,
  centerId_3745,
  centerId_3800,
  centerId_9090,
  centerId_3890,
  centerId_1020,
  centerId_2146,
  centerId_2153,
  centerId_3525,
  centerId_1310,
  centerId_4520,
  centerId_2890,
  centerId_1140,
  centerId_2050,
  centerId_4035,
  centerId_4336,
  centerId_2655,
  centerId_2601,
  centerId_2510,
  centerId_1720,
  centerId_2351,
  centerId_2333,
  centerId_2230,
  centerId_2699,
  centerId_4333,
  centerId_4312,
  centerId_4345,
  centerId_1338,
  centerId_1280,
  centerId_4285,
  centerId_1450,
  centerId_4111,
  centerId_1286,
  centerId_1321,
  centerId_4075,
  centerId_4106,
  centerId_1870,
  centerId_4266,
  centerId_4060,
  centerId_4589,
  centerId_4605,
  centerId_4730,
  centerId_4484,
  centerId_2500,
  centerId_1100,
  centerId_1135,
  centerId_1271,
  centerId_1105,
  centerId_2880,
  centerId_4295,
  centerId_2635,
  centerId_2140,
  centerId_3755,
  centerId_4448,
  centerId_4355,
  centerId_4465,
  centerId_3080,
  centerId_4230,
  centerId_3353,
  centerId_1050,
  centerId_4358,
  centerId_4290,
  centerId_1440,
  centerId_3290,
  centerId_3325,
  centerId_2620,
  centerId_2895,
  centerId_2907,
  centerId_2901,
  centerId_4001,
  centerId_4260,
  centerId_4270,
  centerId_4280,
  centerId_4040,
  centerId_1885,
  centerId_1010,
  centerId_2630,
  centerId_3260,
} as const;

export default Logos;
